const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const getDeadlineFromNow = (days: number): string => new Date(Date.now() + days * MS_PER_DAY).toISOString();

// The date the boost holds until, formatted for display; null when there is no active window
// (no deadline, or it has already elapsed) so the indicator only shows while enhancement is live.
export const getEnhancedUntilDate = (deadline: string | null): string | null => {
    if (!deadline || new Date(deadline).getTime() <= Date.now()) {
        return null;
    }

    return new Date(deadline).toLocaleDateString('en-GB');
};
